import React from 'react';
import Support from '../components/Support';
import Contact from '../components/Contact';
import '../styles/Support.css';

const SupportPage: React.FC = () => {
  return (
    <>
      <Support />
      <Contact />
    </>
  );
};

export default SupportPage;
